import { Component, OnInit } from '@angular/core';
import {
  FormGroup,
  FormBuilder,
  Validators,
  FormControl,
} from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import {
  AuthenticationService,
  CountryService,
  AuctionService,
  EnquiryNowService,
  LoaderService,
} from '../../../../services';
import { BuyerService } from '../../../../services/buyer.service';
import { environment } from '../../../../../environments/environment';
import { AppValidators } from '../../../../core/validators/app-validators';
import { EnquiryNow } from '../../../../models';
import constants from '../../../../utility/constants';
import {  Subscription } from 'rxjs';

@Component({
  selector: 'app-enquiry-now',
  templateUrl: './enquiry-now.component.html',
  styleUrls: ['./enquiry-now.component.css'],
})
export class EnquiryNowComponent implements OnInit {
  captcha = new FormControl();
  enquireNowForm: FormGroup;
  loading: boolean = false;
  submitted: boolean;
  currentUserId: number;
  captchaKey: string;
  isLoggedIn: boolean = false;
  auctionId: number;
  auctionDetail: any;
  private subscriptions: Array<Subscription> = [];

  fieldMaxLength10 = constants.common.validations.maxLength10;
  fieldMaxLength20 = constants.common.validations.maxLength20;
  fieldMaxLength30 = constants.common.validations.maxLength30;
  fieldMaxLength50 = constants.common.validations.maxLength50;
  fieldMaxLength500 = constants.common.validations.maxLength500;

  isdFlagList: any;
  isd: number = 229;
  auctionCode: string;

  returnUrl: string = '/';

  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private toastr: ToastrService,
    private buyerService: BuyerService,
    private authenticationService: AuthenticationService,
    private countryService: CountryService,
    private auctionService: AuctionService,
    private enquiryNowService: EnquiryNowService,
    private loader: LoaderService
  ) {}

  ngOnInit(): void {
    this.route.params.subscribe((params) => {
      this.auctionCode = params['auctionCode'];
      if (this.auctionCode) this.bindDataToForm1();
    });

    this.route.queryParams.subscribe((params) => {
      this.returnUrl = params['returnTo'];
    });

    this.initiateForm();
    this.getCountries();
    this.captchaKey = environment.captchaSiteKey;

    if (this.authenticationService.checkLoggedIn()) {
      this.bindContactUsDetails();
      this.isLoggedIn = true;
    }
  }

  initiateForm() {
    this.enquireNowForm = this.formBuilder.group({
      name: [
        '',
        [
          Validators.required,
          AppValidators.noWhitespace,
          Validators.maxLength(this.fieldMaxLength20),
        ],
      ],
      isdCode: [this.isd, Validators.required],
      mobileNumber: [
        '',
        [
          Validators.required,
          AppValidators.noWhitespace,
          Validators.minLength(this.fieldMaxLength10),
          Validators.maxLength(this.fieldMaxLength30),
        ],
      ],
      email: [
        '',
        [
          Validators.required,
          AppValidators.noWhitespace,
          AppValidators.checkEmail,
          Validators.maxLength(this.fieldMaxLength30),
        ],
      ],
      message: [
        '',
        [
          Validators.required,
          AppValidators.noWhitespace,
          Validators.maxLength(this.fieldMaxLength500),
        ],
      ],
    });
  }

  private bindDataToForm1() {
    this.loader.showLoader(true);
    const auctionDetailByCode = this.auctionService
      .getAuctionDetailByCode(this.auctionCode)
      .subscribe((res: any) => {
        this.loader.showLoader(false);
        this.auctionDetail = res;
      });
      this.subscriptions.push(auctionDetailByCode)
  }

  private getCountries() {
    const countryFlagIsd = this.countryService.getAllCountryFlagIsd().subscribe((res) => {
      this.isdFlagList = res;
    });
    this.subscriptions.push(countryFlagIsd)
  }

  bindContactUsDetails() {
    if(this.authenticationService.currentBuyerValue()?.user.id)
    {
      this.loader.showLoader(true);
      const currentBuyerValue = this.buyerService
      .getById(this.authenticationService.currentBuyerValue()?.user.id)
      .subscribe(
        (response: any) => {
          this.enquireNowForm.patchValue({
            name: response.firstName + ' ' + response.lastName,
            mobileNumber: response.mobileNumber,
            email: response.email,
          });
          this.loader.showLoader(false);
        },
        (err) => {
          this.toastr.error(
            err,
            constants.common.toast.errorTitle,
            constants.common.toast.config
          );
        }
      );
      this.subscriptions.push(currentBuyerValue)
    }
  
  }

  onSubmit() {
    if (this.enquireNowForm.invalid) {
      return;
    }

    this.submitted = true;
    this.loader.showLoader(true);

    let model: EnquiryNow = {
      name: this.enquireNowForm.value.name,
      mobileNumber: this.enquireNowForm.value.mobileNumber,
      email: this.enquireNowForm.value.email,
      isdCode: this.enquireNowForm.value.isdCode,
      message: this.enquireNowForm.value.message,
      auctionId: this.auctionDetail.id,
    };

    const postEnquiry = this.enquiryNowService.postEnquiry(model).subscribe(
      (response) => {
        this.loader.showLoader(false);
        this.toastr.success(
          'Thank you! Your message has been successfully sent. We will contact you as soon as we review your message',
          constants.common.toast.successTitle,
          constants.common.toast.config
        );
        this.enquireNowForm.reset();
        this.enquireNowForm.get('isdCode').setValue(this.isd);
        if (this.authenticationService.checkLoggedIn()) {
          this.bindContactUsDetails();
          this.isLoggedIn = true;
        }
      },
      (err) => {
        this.loading = false;
        this.toastr.error(
          err,
          constants.common.toast.errorTitle,
          constants.common.toast.config
        );
      }
    );
    this.subscriptions.push(postEnquiry)
  }

  onCancel() {
    this.enquireNowForm.reset();
    this.router.navigateByUrl(this.returnUrl);
  }

  goBack() {
    this.router.navigateByUrl(this.returnUrl);
  }

  ngOnDestroy() {
    this.subscriptions.forEach((sub: Subscription) => {
      sub.unsubscribe();
    });
  }
}
